import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  HStack,
} from '@chakra-ui/react';
import type { ReactNode, RefObject } from 'react';

type Props = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  cancelRef: RefObject<HTMLButtonElement>;
  title?: string;
  body?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
};

export const AbandonChangesDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  cancelRef,
  title = 'Abandon changes?',
  body = 'You have unsaved changes. Are you sure you want to abandon them?',
  confirmLabel = 'Yes, Abandon',
  cancelLabel = 'No, Go Back',
}: Props) => (
  <AlertDialog
    isOpen={isOpen}
    leastDestructiveRef={cancelRef}
    onClose={onCancel}
    isCentered
    blockScrollOnMount={false}
  >
    <AlertDialogOverlay />
    <AlertDialogContent>
      <AlertDialogHeader color="text.primary" fontWeight="semibold">
        {title}
      </AlertDialogHeader>
      <AlertDialogBody color="text.primary">{body}</AlertDialogBody>
      <AlertDialogFooter>
        <HStack gap={2}>
          <Button ref={cancelRef} variant="ghost" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button colorScheme="red" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </HStack>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
